import "./index.scss";
import { useSelector } from "react-redux";
import { useTheme } from "../../hook/useThemes";
import { formatNumberForOdds } from "../../utils/utils";

export default function UserBalance() {
  const auth = useSelector((state: any) => state?.auth);
  const { lang } = useTheme();
  return (
    <div className="wrapper-user-balance">
      {lang?.balance || "Balance"}
      <br />
      <span>$ {formatNumberForOdds(auth?.balance)}</span>
    </div>
  );
}
